module.exports = __webpack_public_path__ + "static/img/home_product_06_zh.64b728a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_06_zh.png
// module id = oyeL
// module chunks = 34